import React, { useEffect, useRef } from "react";
import { BiMenuAltLeft } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import IsLoadingHOC from "../../components/Config/common/Loader/Loader";
import UserProfile from "./UserProfile";
import { refreshTokenAction } from "redux/actions";
import { LOG_OUT } from "redux/types/types";
import { saveTokenList, saveAccessToken } from "redux/actions";

const Header = ({ setShowSidebar, showSidebar, ...props }) => {
	const dispatch = useDispatch();
	const token = useSelector((state) => state.user?.token?.accessToken || null);
	const isRefreshingRef = useRef(false); // Track ongoing refresh
	const intervalRef = useRef(null); // Track interval ID

	useEffect(() => {
		if (!token) return;

		const refreshTokenHandle = async () => {
			if (isRefreshingRef.current) return;
			isRefreshingRef.current = true;

			const storedData = localStorage.getItem("userData");
			const userData = storedData ? JSON.parse(storedData) : {};

			if (!userData.refreshToken) {
				dispatch({ type: LOG_OUT });
				isRefreshingRef.current = false;
				clearInterval(intervalRef.current);
				return;
			}

			try {
				const response = await refreshTokenAction({
					refreshToken: userData.refreshToken,
					deviceType: "web",
					deviceId: navigator.userAgent,
				});

				if (!response?.success) throw new Error(response?.message || "Failed to refresh token");

				dispatch(saveAccessToken({
					accessToken: response.accessToken,
					refreshToken: response.refreshToken,
				}));

				localStorage.setItem("userData", JSON.stringify({
					accessToken: response.accessToken,
					refreshToken: response.refreshToken,
				}));

				const tokenList = {
					pointofindia: {
						accessToken: response.accessToken,
						refreshToken: response.refreshToken,
					},
				};
				dispatch(saveTokenList(tokenList));
			} catch (err) {
				console.error("Refresh token failed:", err?.message);
				localStorage.removeItem("userData");
				dispatch({ type: LOG_OUT });
				clearInterval(intervalRef.current);
			} finally {
				isRefreshingRef.current = false;
			}
		};

		// Run immediately only if no refresh is ongoing
		refreshTokenHandle();

		// Set interval once
		intervalRef.current = setInterval(refreshTokenHandle, 30 * 60 * 1000);

		return () => clearInterval(intervalRef.current);
	}, [dispatch]);

	return (
		<div className="w-full flex items-center bg-white pb-4 justify-between px-4 py-2 text-xs ">
			{!showSidebar ? (
				<div className="flex items-center gap-2">
					<button
						className="px-4 py-[0.30rem] text-sm text-[#2b2a2a] rounded flex items-center justify-center gap-1"
						onClick={() => setShowSidebar((state) => !state)}
					>
						<BiMenuAltLeft className="text-sm" />
						<span className="text-xs">Explore</span>
					</button>
				</div>
			) : (
				<div></div>
			)}
			<UserProfile />
		</div>
	);
};

export default IsLoadingHOC(Header, "Refreshing Token Please Wait");
